import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { api } from "@/lib/api";

const STORAGE_KEY = "kipkruiden-warehouse";
const VALID = ["kipkruiden", "vandenbrink"];

export const WAREHOUSE_TABS = [
  { id: "kipkruiden", number: 1, label: "Hoofdmagazijn", short: "Hoofdmagazijn" },
  { id: "vandenbrink", number: 2, label: "Zeewolde (Van den Brink)", short: "Zeewolde" },
];

const WarehouseContext = createContext({ warehouse: "kipkruiden", setWarehouse: () => {} });

function applyHeader(id) {
  api.defaults.headers.common["X-Warehouse"] = id;
  return id;
}

function initial() {
  const stored = localStorage.getItem(STORAGE_KEY);
  return applyHeader(VALID.includes(stored) ? stored : "kipkruiden");
}

export function WarehouseProvider({ children }) {
  const [warehouse, setState] = useState(initial);

  const setWarehouse = useCallback((id) => {
    if (!VALID.includes(id)) return;
    applyHeader(id);
    localStorage.setItem(STORAGE_KEY, id);
    setState(id);
  }, []);

  const value = useMemo(() => ({ warehouse, setWarehouse }), [warehouse, setWarehouse]);
  return <WarehouseContext.Provider value={value}>{children}</WarehouseContext.Provider>;
}

export const useWarehouse = () => useContext(WarehouseContext);
